var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQueuingCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12511 14C8.12511 14.55 8.58023 15 9.13648 15C9.69273 15 10.1478 14.55 10.1478 14C10.1478 13.45 9.69273 13 9.13648 13C8.58023 13 8.12511 13.45 8.12511 14ZM8.12511 0V4H10.1478V2.08C13.5764 2.57 16.216 5.47 16.216 9C16.216 12.87 13.0505 16 9.13648 16C5.22249 16 2.05691 12.87 2.05691 9C2.05691 7.32 2.65362 5.78 3.65487 4.58L9.13648 10L10.5625 8.59L3.68521 1.79V1.81C1.47032 3.45 0.0341797 6.05 0.0341797 9C0.0341797 13.97 4.09987 18 9.13648 18C14.163 18 18.2388 13.97 18.2388 9C18.2388 4.03 14.163 0 9.13648 0H8.12511ZM15.2047 9C15.2047 8.45 14.7496 8 14.1933 8C13.6371 8 13.1819 8.45 13.1819 9C13.1819 9.55 13.6371 10 14.1933 10C14.7496 10 15.2047 9.55 15.2047 9ZM3.06828 9C3.06828 9.55 3.5234 10 4.07965 10C4.6359 10 5.09101 9.55 5.09101 9C5.09101 8.45 4.6359 8 4.07965 8C3.5234 8 3.06828 8.45 3.06828 9Z",
    fill: "#A0CDFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueuingCardIcon);
export default __webpack_public_path__ + "static/media/QueuingCardIcon.48316cfd.svg";
export { ForwardRef as ReactComponent };